<template>
    <div v-if="hasAnyFilters" class="selected-filters-section">
        <div class="selected-filters-container">
            <filter-pill
                v-for="filter in allFilters"
                :key="`${filter.type}-${filter.value}`"
                :value="filter.value"
                :label="filter.label"
                :type="filter.type"
                @remove="handleRemove"
            />
        </div>
    </div>
</template>

<script>
import FilterPill from '../Subscriptions/FilterPill.vue';

export default {
    name: 'PlaybooksActiveFilters',
    components: {
        FilterPill,
    },
    props: {
        selectedYears: {
            type: Array,
            default: () => [],
        },
        selectedMarkets: {
            type: Array,
            default: () => [],
        },
        yearOptions: {
            type: Array,
            default: () => [],
        },
        marketOptions: {
            type: Array,
            default: () => [],
        },
        selectedTopics: {
            type: Array,
            default: () => [],
        },
        topicOptions: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        hasAnyFilters() {
            return (
                this.selectedYears.length > 0 ||
                this.selectedMarkets.length > 0 ||
                this.selectedTopics.length > 0
            );
        },
        allFilters() {
            const filters = [];

            this.selectedYears.forEach((yearId) => {
                const option = this.yearOptions.find((opt) => opt.id === yearId);
                if (option) {
                    filters.push({
                        type: 'year',
                        value: yearId,
                        label: option.name,
                    });
                }
            });

            this.selectedMarkets.forEach((marketId) => {
                const option = this.marketOptions.find((opt) => opt.id === marketId);
                if (option) {
                    filters.push({
                        type: 'market',
                        value: marketId,
                        label: option.name,
                    });
                }
            });

            this.selectedTopics.forEach((topicId) => {
                const option = this.topicOptions.find((opt) => opt.id === topicId);
                if (option) {
                    filters.push({
                        type: 'topic',
                        value: topicId,
                        label: option.name,
                    });
                }
            });

            return filters;
        },
    },
    methods: {
        handleRemove(filter) {
            this.$emit('filter-remove', filter);
        },
    },
};
</script>
